/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderSortingRequestDto } from './OrderSortingRequestDto';
import {
    OrderSortingRequestDtoFromJSON,
    OrderSortingRequestDtoFromJSONTyped,
    OrderSortingRequestDtoToJSON,
    OrderSortingRequestDtoToJSONTyped,
} from './OrderSortingRequestDto';
import type { SearchRequestDto } from './SearchRequestDto';
import {
    SearchRequestDtoFromJSON,
    SearchRequestDtoFromJSONTyped,
    SearchRequestDtoToJSON,
    SearchRequestDtoToJSONTyped,
} from './SearchRequestDto';
import type { PagingRequestDto } from './PagingRequestDto';
import {
    PagingRequestDtoFromJSON,
    PagingRequestDtoFromJSONTyped,
    PagingRequestDtoToJSON,
    PagingRequestDtoToJSONTyped,
} from './PagingRequestDto';

/**
 * 
 * @export
 * @interface GetAllOrdersFilterSortDto
 */
export interface GetAllOrdersFilterSortDto {
    /**
     * 
     * @type {SearchRequestDto}
     * @memberof GetAllOrdersFilterSortDto
     */
    search?: SearchRequestDto;
    /**
     * 
     * @type {PagingRequestDto}
     * @memberof GetAllOrdersFilterSortDto
     */
    paging?: PagingRequestDto;
    /**
     * 
     * @type {OrderSortingRequestDto}
     * @memberof GetAllOrdersFilterSortDto
     */
    sorting?: OrderSortingRequestDto;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrdersFilterSortDto
     */
    orderAmountRangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllOrdersFilterSortDto
     */
    orderAmountRangeMax?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAllOrdersFilterSortDto
     */
    dateRangeMin?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetAllOrdersFilterSortDto
     */
    dateRangeMax?: Date | null;
}

/**
 * Check if a given object implements the GetAllOrdersFilterSortDto interface.
 */
export function instanceOfGetAllOrdersFilterSortDto(value: object): value is GetAllOrdersFilterSortDto {
    return true;
}

export function GetAllOrdersFilterSortDtoFromJSON(json: any): GetAllOrdersFilterSortDto {
    return GetAllOrdersFilterSortDtoFromJSONTyped(json, false);
}

export function GetAllOrdersFilterSortDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllOrdersFilterSortDto {
    if (json == null) {
        return json;
    }
    return {
        
        'search': json['search'] == null ? undefined : SearchRequestDtoFromJSON(json['search']),
        'paging': json['paging'] == null ? undefined : PagingRequestDtoFromJSON(json['paging']),
        'sorting': json['sorting'] == null ? undefined : OrderSortingRequestDtoFromJSON(json['sorting']),
        'orderAmountRangeMin': json['orderAmountRangeMin'] == null ? undefined : json['orderAmountRangeMin'],
        'orderAmountRangeMax': json['orderAmountRangeMax'] == null ? undefined : json['orderAmountRangeMax'],
        'dateRangeMin': json['dateRangeMin'] == null ? undefined : (new Date(json['dateRangeMin'])),
        'dateRangeMax': json['dateRangeMax'] == null ? undefined : (new Date(json['dateRangeMax'])),
    };
}

export function GetAllOrdersFilterSortDtoToJSON(json: any): GetAllOrdersFilterSortDto {
    return GetAllOrdersFilterSortDtoToJSONTyped(json, false);
}

export function GetAllOrdersFilterSortDtoToJSONTyped(value?: GetAllOrdersFilterSortDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search': SearchRequestDtoToJSON(value['search']),
        'paging': PagingRequestDtoToJSON(value['paging']),
        'sorting': OrderSortingRequestDtoToJSON(value['sorting']),
        'orderAmountRangeMin': value['orderAmountRangeMin'],
        'orderAmountRangeMax': value['orderAmountRangeMax'],
        'dateRangeMin': value['dateRangeMin'] == null ? value['dateRangeMin'] : value['dateRangeMin'].toISOString(),
        'dateRangeMax': value['dateRangeMax'] == null ? value['dateRangeMax'] : value['dateRangeMax'].toISOString(),
    };
}

